import { Modal, type ModalProps } from "antd";
import clsx from "clsx";
import "./BModal.scss";

const SLOT_CLASS = {
  mask: "b-modal__mask",
  wrapper: "b-modal__wrapper",
  content: "b-modal__content",
  header: "b-modal__header",
  body: "b-modal__body",
  footer: "b-modal__footer",
} as const;

const BModal = ({
  className,
  wrapClassName,
  classNames,
  styles,
  centered = true,
  ...props
}: ModalProps) => (
  <Modal
    {...props}
    className={clsx("b-modal", className)}
    wrapClassName={clsx("b-modal__wrap", wrapClassName)}
    centered={centered}
    classNames={{
      mask: clsx(SLOT_CLASS.mask, classNames?.mask),
      wrapper: clsx(SLOT_CLASS.wrapper, classNames?.wrapper),
      content: clsx(SLOT_CLASS.content, classNames?.content),
      header: clsx(SLOT_CLASS.header, classNames?.header),
      body: clsx(SLOT_CLASS.body, classNames?.body),
      footer: clsx(SLOT_CLASS.footer, classNames?.footer),
    }}
    styles={{
      ...styles,
      mask: {
        background: "rgba(0, 0, 0, 0.12)",
        backdropFilter: "blur(2px)",
        WebkitBackdropFilter: "blur(2px)",
        ...styles?.mask,
      },
    }}
  />
);

export default BModal;
